import {Component, output} from '@angular/core';

@Component({
  selector: 'submit-service-request-popup',
  standalone: true,
  templateUrl: './submit-service-request-popup.component.html',
  styleUrl: './submit-service-request-popup.component.css'
})
export class SubmitServiceRequestPopupComponent {
  close = output();
  submit = output();
  submitAndCreatePdf = output();

  closeModal() {
    this.close.emit();
  }

  onSubmit() {
    this.submit.emit();
  }

  onSubmitAndCreatePdf() {
    this.submitAndCreatePdf.emit();
  }
}
